
import { FieldToComplete, PromptInfo } from "@/lib/ai/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import ToggleInput from "../Reusable/CustomInputs/ToggleInput.vue";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";
import defensiveCopy from "@/util/defensive-copy";
import lodash from "lodash";
import { uiStore } from "@/store/store-accessor";
import { TreeNode } from "@/types/tree";

@Component({
  components: {
    Icon,
    TextInput,
    NiceButton,
    NumberInput,
    ToggleInput,
    AlertBox
  }
})
export default class AIWriter extends Vue {
  @Prop()
  prompt!: PromptInfo;

  @Prop()
  title!: string;

  @Prop({
    default: false
  })
  loading!: boolean;

  @Prop({
    default: false
  })
  disabled!: boolean;

  @Prop({
    default: ""
  })
  elementName!: string;

  @Prop({
    default() {
      return [];
    }
  })
  lockedFields!: FieldToComplete[];

  viewWarning = false;

  updateField(
    property: "sectionDescription" | "qualifiers" | "temperature",
    newValue: string | number
  ) {
    const newPrompt = defensiveCopy(this.prompt);
    lodash.set(newPrompt, property, newValue);
    this.$emit("updatePrompt", newPrompt);
  }

  updateTemperature(newValue: number) {
    const clamped = Math.max(0, Math.min(1, newValue));
    this.updateField("temperature", clamped);
  }

  isActiveElement(nodeId: TreeNode["id"]) {
    return uiStore.activeElementId === nodeId;
  }

  activateElement(nodeId: TreeNode["id"]) {
    uiStore.activateElement(nodeId);
  }
}
